export const socialProfileLabels = {
    behance: 'Behance',
    github: 'Github',
    medium: 'Medium',
    linkedin: 'LinkedIn',
    mail: 'Mail',
};
